export default "/assets/dc277005dc95c8e8.svg"